import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  connect() {
    if (this.element.dataset.open === "true") {
      this.open()
    } else {
      this.close()
    }
  }

  toggle() {
    this.menuTarget.classList.contains("hidden") ? this.open() : this.close()
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.iconTarget.classList.add("rotate-180")
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.iconTarget.classList.remove("rotate-180")
  }
}
